import React, { useState } from "react";
import {
  AreaSeries,
  HorizontalGridLines,
  GradientDefs,
  VerticalGridLines,
  XAxis,
  XYPlot,
  makeVisFlexible,
  YAxis,
  Crosshair,
  LineSeries,
} from "react-vis";
import Moment from "react-moment";
import moment from "moment";
const toINR = (num) => {
  return "₹ " + parseInt(num).toLocaleString("en-IN");
};
const Flexible = makeVisFlexible(XYPlot);
export default (props) => {
  const DATA = props.data
    .filter((ti, ti_ind) => {
      if (ti_ind === props.data.length - 1) return true;
      if (ti.x === props.data[ti_ind + 1].x) return false;
      return true;
    })
    .map((elem) => {
      return { ...elem, x: new Date(elem.x) };
    });

  const [crosshairValues, setCrosshairValues] = useState([]);

  const _onNearestX = (value, { index }) => {
    setCrosshairValues([value]);
  };
  const _onMouseLeave = () => {
    setCrosshairValues([]);
  };
  const trimSet = (arr) => {
    const hobe = [];
    if (arr.length < 10) return arr;
    return arr.filter(function (v, i) {
      const id = moment(v).format("MM-YYYY");
      if (hobe.includes(id)) return false;
      else {
        hobe.push(id);
        return true;
      }
    });
  };

  return (
    <Flexible
      className="viz-offset"
      height={200}
      margin={{ left: 100 }}
      stackBy="y"
      xType="time"
      onMouseLeave={_onMouseLeave}
      tickFormat
    >
      <GradientDefs>
        <linearGradient id="CoolGradient" x1="0" x2="0" y1="0" y2="1.5">
          <stop offset="0%" stopColor="#00b6ff" stopOpacity={0.24} />
        </linearGradient>
      </GradientDefs>

      <HorizontalGridLines />

      <XAxis
        tickFormat={(v) => moment(v).format("MMM DD")}
        tickValues={trimSet(DATA.map((d) => d.x))}
      />
      <YAxis />
      <AreaSeries
        onNearestX={_onNearestX}
        color="url(#CoolGradient)"
        data={DATA}
        animation="wobbly"
        curve={"curveMonotoneX"}
      />
      <Crosshair values={crosshairValues}>
        {crosshairValues[0] && (
          <div className="label-wrapper">
            <div className="label-header">
              <Moment format="MMMM DD, YYYY">{crosshairValues[0].x}</Moment>
            </div>
            <div className="label-title">{props.title}</div>
            <div className="label-value">{toINR(crosshairValues[0].y)}</div>
          </div>
        )}
      </Crosshair>
    </Flexible>
  );
};
